<app-mat-spinner-overlay
  [mode]="mode"
  [value]="progressImport"
  *ngIf="showSpinner"
>
</app-mat-spinner-overlay>
<ng-container>
  <div class="row mt-4">
    <!-- Import Section -->
    <div class="col-md-12 mb-3">
      <div class="card shadow-sm border-primary">
        <div class="card-header bg-primary text-white font-weight-bold">
          <i class="fa fa-upload mr-2"></i>Import Data
        </div>
        <div class="card-body d-flex flex-wrap justify-content-start gap-3">
          <label
            class="btn font-size-12 button-btn btn-outline-primary mr-2"
            for="uploadLoan"
            >Import Loan</label
          >
          
          <label
            class="btn font-size-12 button-btn btn-outline-primary"
            for="uploadAccounting"
            >Import Accounting</label
          >
          <input
  type="file"
  id="uploadLoan"
  style="visibility: hidden"
  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  (change)="onLoanFileChange($event)"
/>
<input
  type="file"
  id="uploadAccounting"
  style="visibility: hidden"
  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  (change)="onAccountingFileChange($event)"
/>
        </div>
      </div>
    </div>

    <!-- Template Download Section -->
    <div class="col-md-12 mb-3">
      <div class="card shadow-sm border-success">
        <div class="card-header bg-success text-white font-weight-bold">
          <i class="fa fa-download mr-2"></i>Download Templates
        </div>
        <div class="card-body d-flex flex-wrap justify-content-start gap-3">
          <button
            (click)="exportAsLoanExcelFile('Loan Template')"
            class="btn font-size-12 button-btn btn-outline-success mr-2"
          >
            Download Loan Template
          </button>
          <button
            (click)="exportAsAccountingExcelFile('Accounting Template')"
            class="btn font-size-12 button-btn btn-outline-success"
          >
            Download Accounting Template
          </button>
        </div>
      </div>
    </div>

    <!-- Master Data Download Section -->
    <div class="col-md-12 mb-3">
      <div class="card shadow-sm border-info">
        <div class="card-header bg-info text-white font-weight-bold">
          <i class="fa fa-list-alt mr-2"></i>Download Master Lists
        </div>
        <div class="card-body d-flex flex-wrap justify-content-start gap-3">
          <button
            (click)="exportAsHeadlistExcelFile('Head list')"
            class="btn font-size-12 button-btn btn-outline-info mr-2"
          >
            Download Master Charges Head list
          </button>
          <button
            (click)="exportAsBranchlistExcelFile('Branch list')"
            class="btn font-size-12 button-btn btn-outline-info mr-2"
          >
            Download Master Branch list
          </button>
          <button
            (click)="exportAsAccountMasterlistExcelFile('Account Master list')"
            class="btn font-size-12 button-btn btn-outline-info"
          >
            Download Master Accounting list
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- import table -->
   <!-- Loan Import Preview -->
<div class="col-md-12 mb-3" *ngIf="Matchhdata.length > 0">
  <div class="card shadow-sm border-secondary">
    <div class="card-header bg-secondary text-white font-weight-bold">
      <i class="fa fa-table mr-2"></i>Preview Imported Loan Data
    </div>
    <div class="card-body table-responsive">
      <table mat-table [dataSource]="dataSourceBulkImport" class="mat-elevation-z1 w-100">
        <ng-container *ngFor="let col of displayedColumnsBulkImport" [matColumnDef]="col">
          <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
          <td mat-cell *matCellDef="let element">{{ element[col] }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsBulkImport"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsBulkImport"></tr>
      </table>
    </div>
  </div>
</div>

<!-- Accounting Import Preview -->
<div class="col-md-12 mb-3" *ngIf="uploadedAccountingData.length > 0">
  <div class="card shadow-sm border-secondary">
    <div class="card-header bg-secondary text-white font-weight-bold">
      <i class="fa fa-table mr-2"></i>Preview Imported Accounting Data
    </div>
    <div class="card-body table-responsive">
      <table mat-table [dataSource]="uploadedAccountingDataSource" class="mat-elevation-z1 w-100">
        <ng-container *ngFor="let col of uploadedAccountingColumns" [matColumnDef]="col">
          <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
          <td mat-cell *matCellDef="let element">{{ element[col] }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="uploadedAccountingColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: uploadedAccountingColumns"></tr>
      </table>
    </div>
  </div>
</div>


</ng-container>
